import axios from 'axios';
import baseUrl from 'config/baseUrl';

if (baseUrl) {
  axios.defaults.baseURL = baseUrl;
  axios.defaults.withCredentials = true;
}

axios.defaults.headers.common.Pragma = 'no-cache';
axios.defaults.headers.common['Cache-Control'] = 'no-cache, no-store';
